import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { routes } from "./router";
import Header from "./layouts/Header";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DoctorDashboardSidebar2 from "./components/DoctorDashboardSidebar2";
import { useIdleLogout, useSessionMonitor } from "./hooks";
import { SessionExpiryModal } from "./components";

function App() {
  const { showSessionModal, handleStaySignedIn, handleLogout } =
    useSessionMonitor();

  // This hook is used to log out the user after a period of inactivity
  // It will redirect to the login page after logging out
  // useIdleLogout();

  return (
    <>
      <ToastContainer autoClose={3000} position="top-right" />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {routes.map(({ path, component: Component, layout, title }) => (
            <Route
              key={path}
              path={path}
              element={
                layout === "modern" ? (
                  // New Pages with sidebar + header
                  <div className="flex flex-col h-screen w-screen bg-white">
                    <div className="flex h-full overflow-hidden">
                      <DoctorDashboardSidebar2 isAdminDashboard={true} />
                      <div className="flex-1 w-5/6 overflow-auto">
                        <Header title={title} />
                        <div className="p-2 px-4">
                          <Component />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Component />
                )
              }
            />
          ))}
        </Routes>
      </Suspense>
      {showSessionModal && (
        <SessionExpiryModal
          onStay={handleStaySignedIn}
          onLogout={handleLogout}
        />
      )}
    </>
  );
}

export default App;
